import { Images } from "@assets/images";

function InformationSecurityPolicy() {
  return (
    <div className="bg-gray-100 min-h-screen flex justify-center py-8">
      <div className="px-4 md:px-10 py-8 bg-white shadow-md rounded-lg max-w-screen-lg mx-auto">
        <div className="flex justify-center mb-8">
          <img
            className="w-2/3 md:w-1/3"
            src={Images.LogoText.default}
            alt="Logo"
          />
        </div>
        <h1 className="text-2xl md:text-3xl font-bold mb-4 text-gray-800 text-center">
          Chính Sách Bảo Mật Thông Tin
        </h1>
        <div className="text-gray-600 text-sm md:text-base">
          <ol className="list-decimal ml-6">
            <li className="font-bold">
              Mục đích và phạm vi thu thập thông tin của Website Ứng dụng
              App.bookas.vn và Ứng Dụng Bookas trên di động, gọi tắt là
              “Bookas”.
            </li>
            <p className="my-2">
              <strong>Bookas</strong> không bán, chia sẻ hay trao đổi thông tin
              cá nhân của khách hàng thu thập trên trang web cho một bên thứ ba
              nào khác.
            </p>
            <p className="my-2">
              Thông tin cá nhân thu thập được sẽ chỉ được sử dụng trong nội bộ
              công ty.
            </p>
            <p className="my-2">
              Khi bạn liên hệ đăng ký dịch vụ, thông tin cá nhân mà{" "}
              <strong>Bookas</strong> thu thập bao gồm:
            </p>
            <ul className="list-disc ml-6">
              <li className="my-2">Họ và tên</li>
              <li className="my-2">Địa chỉ</li>
              <li className="my-2">Điện thoại</li>
              <li className="my-2">Email</li>
            </ul>
            <p className="my-2">
              Ngoài thông tin cá nhân là các thông tin về dịch vụ
            </p>
            <ul className="list-disc ml-6">
              <li className="my-2">Tên sản phẩm</li>
              <li className="my-2">Số lượng</li>
              <li className="my-2">Thời gian giao nhận sản phẩm</li>
            </ul>
            <li className="font-bold">Phạm vi sử dụng thông tin</li>
            <p className="my-2">
              Thông tin cá nhân thu thập được sẽ chỉ được{" "}
              <strong>Bookas</strong> sử dụng trong nội bộ công ty và cho một
              hoặc tất cả các mục đích sau đây:
            </p>
            <ul className="list-disc ml-6">
              <li className="my-2"> Hỗ trợ khách hàng</li>
              <li className="my-2">
                {" "}
                Cung cấp thông tin liên quan đến dịch vụ
              </li>
              <li className="my-2">
                Xử lý đơn đặt hàng và cung cấp dịch vụ và thông tin qua trang
                web của chúng tôi theo yêu cầu của bạn
              </li>
              <li className="my-2">
                Chúng tôi có thể sẽ gửi thông tin sản phẩm, dịch vụ mới, thông
                tin về các sự kiện sắp tới hoặc thông tin tuyển dụng nếu quý
                khách đăng kí nhận email thông báo.
              </li>
              <li className="my-2">
                Ngoài ra, chúng tôi sẽ sử dụng thông tin bạn cung cấp để hỗ trợ
                quản lý tài khoản khách hàng; xác nhận và thực hiện các giao
                dịch tài chính liên quan đến các khoản thanh toán trực tuyến của
                bạn;
              </li>
            </ul>
            <li className="font-bold">Thời gian lưu trữ thông tin</li>
            <p className="my-2">
              Đối với thông tin cá nhân, <strong>Bookas</strong> chỉ xóa đi dữ
              liệu này nếu khách hàng có yêu cầu, khách hàng yêu cầu gửi mail về{" "}
              <span className="decoration-solid">sachnoibookas@gmail.com</span>
            </p>
            <li className="font-bold">
              Những người hoặc tổ chức có thể được tiếp cận với thông tin cá
              nhân
            </li>
            <p className="my-2">
              Đối tượng được tiếp cận với thông tin cá nhân của khách hàng thuộc
              một trong những trường hợp sau:
            </p>
            <ul className="list-disc ml-6">
              <li className="my-2"> CÔNG TY CỔ PHẦN BOOKAS</li>
              <li className="my-2">
                Các đối tác có ký hợp động thực hiện 1 phần dịch vụ do CÔNG TY
                CỔ PHẦN BOOKAS. Các đối tác này sẽ nhận được những thông tin
                theo thỏa thuận hợp đồng (có thể 1phần hoặc toàn bộ thông tin
                tuy theo điều khoản hợp đồng) để tiến hành hỗ trợ người dùng sử
                dụng dịch vụ do Công ty cung cấp.
              </li>
            </ul>
            <li className="font-bold">
              Địa chỉ của đơn vị thu thập và quản lý thông tin cá nhân
            </li>
            <p className="my-2">
              Để hỏi về hoạt động thu thập, xử lý thông tin liên quan đến cá
              nhân mình, KH có thể liên hệ trực tiếp qua địa chỉ công ty hoặc
              mail và số điện thoại sau:
            </p>
            <p className="my-2 font-bold">Công ty cổ phần Bookas</p>
            <p className="my-2 font-bold">
              Địa chỉ: Số 124 đường số 2 KDC Vạn Phúc, P. Hiệp Bình Phước, Tp.
              Thủ Đức, Tp. Hồ Chí Minh
            </p>
            <p className="my-2 font-bold">Điện thoại: 0931814258</p>
            <p className="my-2 font-bold">Website: App.bookas.vn</p>
            <p className="my-2">
              Ứng dụng Bookas trên IOS :{" "}
              <a
                href="https://apps.apple.com/vn/app/bookas/id6478921196"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://apps.apple.com/vn/app/bookas/id6478921196
              </a>
            </p>
            <p className="my-2">
              Ứng Dụng Bookas trên Android :{" "}
              <a
                href="https://bit.ly/bookasapp"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://bit.ly/bookasapp
              </a>
            </p>
            <p className="my-2 font-bold">Email: sachnoibookas@gmail.com</p>
            <li className="font-bold">
              Phương tiện và công cụ để người dùng tiếp cận và chỉnh sửa dữ liệu
              cá nhân của mình
            </li>
            <p className="my-2">
              <strong>Bookas</strong> thu thập thông tin khách hàng qua trang
              web, thông tin cá nhân khách hàng được thực hiện thu thập qua
              email liên hệ đặt mua sản phẩm, dịch vụ gửi về hộp mail của chúng
              tôi: Sachnoibookas@gmail.com hoặc số điện thoại liên hệ đặt mua
              sản phẩm gọi về 0931814258
            </p>
            <p className="my-2">
              Bạn có thể liên hệ địa chỉ email cùng số điện thoại trên để yêu
              cầu Bookas chỉnh sửa dữ liệu cá nhân của mình.
            </p>
            <li className="font-bold">
              Cơ chế tiếp nhận và giải quyết khiếu nại của người tiêu dùng liên
              quan đến việc thông tin cá nhân bị sử dụng sai mục đích hoặc phạm
              vi đã thông báo.
            </li>
            <p className="my-2">
              Tại <strong>Bookas</strong>, việc bảo vệ thông tin cá nhân của bạn
              là rất quan trọng, bạn được đảm bảo rằng thông tin cung cấp cho
              chúng tôi sẽ được mật Bookas cam kết không chia sẻ, bán hoặc cho
              thuê thông tin cá nhân của bạn cho bất kỳ người nào khác.{" "}
              <strong>Bookas</strong> cam kết chỉ sử dụng các thông tin của bạn
              vào các trường hợp sau:
            </p>
            <ul className="list-disc ml-6">
              <li className="my-2">
                {" "}
                Nâng cao chất lượng dịch vụ dành cho khách hàng
              </li>
              <li className="my-2"> Giải quyết các tranh chấp, khiếu nại</li>
              <li className="my-2"> Khi cơ quan pháp luật có yêu cầu.</li>
            </ul>
            <p className="my-2">
              <strong>Bookas</strong> hiểu rằng quyền lợi của bạn trong việc bảo
              vệ thông tin cá nhân cũng chính là trách nhiệm của chúng tôi nên
              trong bất kỳ trường hợp có thắc mắc, góp ý nào liên quan đến chính
              sách bảo mật của <strong>Bookas</strong>, và liên quan đến việc
              thông tin cá nhân bị sử dụng sai mục đích hoặc phạm vi đã thông
              báo vui lòng liên hệ qua số hotline 0931814258 hoặc email:
              sachnoibookas@gmail.com
            </p>
            <p className="my-2 text-blue-400 decoration-solid">
              <a
                href="https://bookas.vn/policies/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Xem thêm chính sách bảo mật
              </a>
            </p>
          </ol>
        </div>
      </div>
    </div>
  );
}

export default InformationSecurityPolicy;
